import api from '../services/api';
import { ISale, ISaleDetails } from '../shared/interfaces';

interface IResponseGetSales {
  data: ISale[];
  count: number;
}

export const getSales = async (
  take: number,
  skip: number,
  keyword?: string,
  type?: string,
): Promise<IResponseGetSales> => {
  const response = await api.post('/sales/list', {
    take,
    skip,
    keyword,
    type,
  });

  return response.data;
};

export const getSale = async (id: string): Promise<ISaleDetails> => {
  const response = await api.get(`/sales/${id}`);
  return response.data;
};
